import { ButtonGroup } from "@/components/control-bar/ButtonGroup";
import { getTranslation, Lang } from "@/data/translation";
import { PortfolioReturnsPeriod } from "@/services/custom-portfolio/custom-portfolio-returns";
import { ChartKey } from "@/types/chart";
import { useState } from "react";

export const useCustomPortfolioReturnsController = ({
  lang,
  chartKey,
}: {
  lang: Lang;
  chartKey: ChartKey;
}) => {
  const { t } = getTranslation({ lang });
  const [period, setPeriod] =
    useState<PortfolioReturnsPeriod>("cumulativeReturns");

  const onClick = (value: string) => {
    setPeriod(value as PortfolioReturnsPeriod);
  };

  const CustomPortfolioReturnController = () =>
    chartKey === "custom_portfolio_returns" ? (
      <ButtonGroup
        value={period}
        options={[
          {
            label: t.customPortfolioReturns.cumulativeReturn,
            value: "cumulativeReturns",
          },
          {
            label: t.customPortfolioReturns.yearlyReturn,
            value: "yearlyReturns",
          },
        ]}
        onButtonClick={onClick}
        className="max-w-xs"
      />
    ) : null;

  return {
    CustomPortfolioReturnController,
    portfolioReturnsPeriod: period,
  };
};
